import {request} from '../utils/request';
import {GET, POST, PATCH, PUT} from '../constants/API_CONSTANTS';
import {
  GET_BYOC_ONBOARDING_DATA,
  SAVE_BYOC_SIGNATURE,
  SAVE_BYOC_ADJUSTMENT_PRICE_RULES,
  UPDATE_BYOC_PLATFORMS,
  GET_BYOC_SELF_DELIVERY_LINK,
  UPDATE_BYOC_ONBOARDING_STEP,
  GET_ANALYTICS_INFO
} from '../constants/API_ENDPOINTS';

export const getByocOnboardingDataApi = async (locationId) => {
  return request(GET, GET_BYOC_ONBOARDING_DATA(locationId));
};

export const saveByocAdjustmentPriceRulesApi = async (locationId, data) => {
  return request(PUT, SAVE_BYOC_ADJUSTMENT_PRICE_RULES(locationId), {
    data
  });
};

export const updateByocPlatformsApi = async (locationId, data) => {
  return request(PATCH, UPDATE_BYOC_PLATFORMS(locationId), {
    data
  });
};

export const getByocSelfDeliveryLinkApi = async (locationId, data) => {
  return request(POST, GET_BYOC_SELF_DELIVERY_LINK(locationId), {
    data
  });
};

export const updateByocOnboardingStepApi = async (locationId, data) => {
  return request(PATCH, UPDATE_BYOC_ONBOARDING_STEP(locationId), {
    data
  });
};

export const saveByocSignatureApi = async (locationId, signature) => {
  return request(PUT, SAVE_BYOC_SIGNATURE(locationId), {
    data: {signature}
  });
};

export const getAnalyticsInfoApi = async (locationId) => {
  return request(GET, GET_ANALYTICS_INFO(locationId));
};
